import { Download } from '@mui/icons-material';
import { Button, useMediaQuery, useTheme } from '@mui/material';

export interface DownloadAOIProps {
  AOI: GeoJSON.FeatureCollection | undefined;
  variant?: 'IconOnly' | 'IconAndText';
  disabled?: boolean;
}

export const DownloadAOIComponent: React.FC<DownloadAOIProps> = ({ AOI, disabled, variant }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!variant) variant = 'IconAndText';
  const downloadAOI = () => {
    if (AOI) {
      const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(AOI));
      const downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute('href', dataStr);
      downloadAnchorNode.setAttribute('download', `AOI_${new Date().toISOString()}.geojson`);
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    }
  };

  return (
    <Button
      variant="contained"
      className="hide-on-fullscreen"
      onClick={downloadAOI}
      disabled={disabled}
      sx={{
        textAlign: 'center',
        display: { xs: 'none', sm: 'flex' },
        backgroundColor: 'var(--gentian-blue)', // Set the background color to --sundrop-yellow
        color: 'var(--gentian-white)', // Set the text color to --gentian-black for contrast
        '&:hover': {
          backgroundColor: 'var(--eclipse-black)',
        },
      }}
    >
      {!isMobile && variant === 'IconAndText' && 'Download Boundary'}
      <Download />
    </Button>
  );
};
